// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    RESET_COMPANY_AUTHENTICATION_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    resetCompAuthenticationResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* resetCompanyAuthentication({ payload }) {
    try {
        let QUERY = `
            mutation resetCompanyAuthentication ($id: Int!) {
                result: resetCompanyAuthentication (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(resetCompAuthenticationResult({ reset: data?.result }))

    } catch (exc) {
        if (data?.result) yield put(resetCompAuthenticationResult({ reset: false }))
        ExceptionManager(exc, 'Modules/accounts/views/components/resetCompanyAuthentication/redux/saga', 'resetCompanyAuthentication');
    }
}

function* watchMethods() {
    yield takeEvery(RESET_COMPANY_AUTHENTICATION_REQUEST, resetCompanyAuthentication);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}